module.exports = __webpack_public_path__ + "static/media/billing_large_new.f32e6225.png";